import { VeltUserRequestTool } from '@veltdev/react';
import React from 'react'
import './ContactUsPage.css';

function ContactUsPage() {
    return (
        <div id="userRequestToolContainer">
            <div className="user-request-tool-main-view">
                <p className="boujeeText">Click on the button below to contact us.</p>
                <div className='user-request-tools-container'>
                    <VeltUserRequestTool type='contactUs' />
                </div>
            </div>
        </div>
    )
}

export default ContactUsPage;